// extracted by mini-css-extract-plugin
module.exports = {"List":"CountryList_List__25G8c","ListItem":"CountryList_ListItem__2ZVnX","Stats":"CountryList_Stats__3-WxK","Flag":"CountryList_Flag__329Is","Name":"CountryList_Name__3mFui"};